export const COST_CENTERS = [
  "02 - Labor",
  "03 - Equipment",
  "04 - Material",
  "05 - Subcontratos",
  "06 - Other",
  "07 - Chiveros",
];

export const EXPENSE_CATEGORIES = [
  "Travel & Transportation",
  "Meals & Entertainment",
  "Software & Subscriptions",
  "Office Supplies",
  "Hardware & Equipment",
  "Training & Education",
  "Marketing & Advertising",
  "Professional Services",
  "Utilities",
  "Other",
];

export const STATUS_COLORS = {
  draft:               { bg: "#F3F0FF", text: "#4A2D9E", border: "#BDB0E8" },
  pending:             { bg: "#FEF9C3", text: "#854D0E", border: "#eab308" },
  sent_back:           { bg: "#FFF7ED", text: "#9A3412", border: "#ea580c" },
  approved:            { bg: "#DCFCE7", text: "#166534", border: "#22c55e" },
  rejected:            { bg: "#FEE2E2", text: "#991B1B", border: "#dc2626" },
  partially_approved:  { bg: "#DBEAFE", text: "#1E40AF", border: "#2563eb" },
  partially_returned:  { bg: "#FEF3C7", text: "#92400E", border: "#d97706" },
  pending_review:      { bg: "#EDE9FE", text: "#5B21B6", border: "#7c3aed" },
  paid:                { bg: "#CCFBF1", text: "#115E59", border: "#0d9488" },
};

export const STATUS_LABEL = {
  draft:               'Sin Enviar',
  pending:             'Pendiente',
  sent_back:           'Devuelto',
  approved:            'Aprobado',
  rejected:            'Rechazado',
  partially_approved:  'Parcialmente Aprobado',
  partially_returned:  'Parcialmente Devuelto',
  pending_review:      'Pendiente de Revisión',
  paid:                'Pagado',
};

export const REJECTION_REASONS = [
  "Recibo faltante o ilegible",
  "Gasto personal — no elegible para reembolso",
  "Envío duplicado",
  "Monto excede el límite de la política",
  "Fuera de la categoría de gastos aprobada",
  "Fecha del recibo fuera del período permitido",
  "Otro",
];

export const PAYMENT_METHODS = {
  credit_card: 'Tarjeta de Crédito',
  petty_cash: 'Petty Cash',
};

export const PR_TAX_RATES = [
  { value: 11.5, label: '11.5% — IVU Estándar' },
  { value: 7,    label: '7% — IVU Reducido (Alimentos)' },
  { value: 4,    label: '4% — B2B (Servicios)' },
  { value: 0,    label: '0% — Exento' },
];

// Unpaid absence reasons (Nómina V25)
// Paid absences keep using cost codes (01102/01104/01107/01108/01109/01110).
export const ABSENCE_REASONS = {
  class:    'Clase',
  absence:  'Ausencia',
  personal: 'Personal',
};

export const SENDBACK_REASONS = [
  "Información del proveedor incompleta",
  "Monto poco claro o faltante",
  "Fecha faltante o incorrecta",
  "Categoría o centro de costo requiere corrección",
  "Descripción insuficiente",
  "Documentación adicional requerida",
  "Otro",
];
